const CONFIG = {
  URL: "https://wcuagm2025-api.eventqiu.com/api",
  TOKEN_VOTING: "eyJpZF9hZG1pbiI6IjE3IiwidG9rZW4iOiJtM3ViU2FmTExxUEpNMnlYWUg1NTE3Iiwicm9sZSI6ImFkbWluIn0.ossQi7JwwhuyTq_JWaFvLDv2QTMRd7qWD2XavU9Rptg"
};

export default CONFIG;
